import { useAction, useAtom } from '@reatom/npm-react'
import React from 'react'
import styled from 'styled-components'

import { CurrencyCenteredAmount } from '@root/entities/currency/ui'

import { TransferAmountBalance } from './transfer-amount-balance'

import type { TransferAmountReatom } from '../../../atoms/transfer-amount-reatom'
import type { TransferCurrencyReatom } from '../../../atoms/transfer-currency-reatom'
import type { ValidationError } from '../../../atoms/transfer-flow'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  amountModel: TransferAmountReatom
  currencyModel: TransferCurrencyReatom
  validation: ValidationError | undefined
} & ClassNameProps

export const TransferAmount: React.FC<Props> = ({
  amountModel,
  currencyModel,
  className,
  validation,
}) => {
  const [currency] = useAtom(currencyModel.currencyAtom)
  const [balance] = useAtom(amountModel.balanceAtom)
  const [amountRaw] = useAtom(amountModel.amountRawAtom)
  const [amountUsdtState] = useAtom(amountModel.amountUsdStateAtom)
  const [isMaxAmount] = useAtom(amountModel.isMaxAmountAtom)

  const setMaxAmount = useAction(amountModel.setMaxAmountAction)
  const setAmount = useAction(amountModel.setAmountAction)

  return (
    <Root className={className}>
      <TransferAmountBalance balance={balance} currency={currency} />
      <CurrencyCenteredAmount
        amountRaw={amountRaw}
        amountUsdState={amountUsdtState}
        currency={currency}
        isMax={isMaxAmount}
        onMaxClick={setMaxAmount}
        onChange={setAmount}
        validation={
          validation?._tag === 'InsufficientBalance'
            ? 'insufficient-balance'
            : undefined
        }
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;

  justify-content: center;
  justify-items: center;
  align-self: center;
  gap: 8px;
`
